import { useAuth } from '@/contexts/AuthContext';
import { type VideoConfiguration, videoRequest } from '@/lib/telehealthApi';
import { useQuery } from '@tanstack/react-query';

export const useTelehealth = () => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['telehealth', 'configuration', user?.authAccountId, user?.authOrgId],
    queryFn: () => videoRequest<VideoConfiguration>('/config'),
    enabled: Boolean(user?.authOrgId),
    retry: false,
  });
};
